function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#39C",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.5.87a8.63 8.63 0 1 1 0 17.26A8.63 8.63 0 0 1 9.5.87zm0 1a7.63 7.63 0 1 0 0 15.26 7.63 7.63 0 0 0 0-15.26z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.217 7.652a2.718 2.718 0 0 0-5.434 0 .5.5 0 1 0 1 0A1.718 1.718 0 1 1 9.5 9.37a.5.5 0 0 0-.5.5v2.217a.5.5 0 1 0 1 0v-1.763a2.718 2.718 0 0 0 2.217-2.672zM9.5 13.065a.87.87 0 1 1 0 1.74.87.87 0 0 1 0-1.74z"
}));

var SvgDoubtIcon = function SvgDoubtIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDoubtIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/doubt_icon.96a0d88e.svg";
export { ForwardRef as ReactComponent };